import { Newsflash, NewsflashSeverity } from '../../api/newsflashService'

export const SEVERITY_TAG: Record<NewsflashSeverity, string> = {
  info: 'Info',
  warning: 'Heads up',
  critical: 'Action',
}

export const SEVERITY_LABEL: Record<NewsflashSeverity, string> = {
  info: 'Information',
  warning: "Changes today's work",
  critical: 'Must act',
}

/** "until 8 Oct 20:00" from a UK-time timestamp, without a timezone shift. */
export function untilLabel(endsAt: string | null): string {
  if (!endsAt) return ''
  const [day, time] = endsAt.split('T')
  const [y, m, d] = day.split('-').map(Number)
  const month = new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-GB', {
    month: 'short',
    timeZone: 'UTC',
  })
  return `until ${d} ${month} ${(time ?? '').slice(0, 5)}`.trim()
}

/**
 * Which newsflash the banner shows after the list changes: the same one if it
 * is still there, otherwise the one now at the old position (or the last).
 */
export function keepPosition(previous: Newsflash[], next: Newsflash[], index: number): number {
  if (!next.length) return 0
  const currentId = previous[index]?.newsflashId
  const same = next.findIndex(n => n.newsflashId === currentId)
  if (same >= 0) return same
  return Math.min(index, next.length - 1)
}
